import { Box, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import GlassModal from '../../../../v2/MUI_custom_component/Modal/GlassModal';
import { CustomButton } from '../../../../v2/MUI_custom_component';

const ResidentCheckModal = ({ open, onYes, onNo }) => {
  return (
    <GlassModal
      open={open}
      onClose={onNo}
      title="What You'll Need"
      topMobile='22%'
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant='h2'>Are you a Resident Indian?</Typography>

          {/* Warning */}
          <Box
            sx={{
              display: 'flex',
              gap: 0.5,
              flexDirection:'row',
              alignItems: 'center',
              pt: 0.25,
            }}
          >
            <WarningAmberIcon
              sx={{
                color: '#CC0000',
                flexShrink: 0,
                fontSize: 16,
              }}
            />
            <Typography variant='body1' color='#CC0000'>
              NPS is only applicable for Resident Indians.
            </Typography>
          </Box>
        </Box>

        {/* Buttons */}
        <Box sx={{ display: 'flex', gap: 1 }}>
          <CustomButton
            variant='outlined'
            color='primary'
            label='No'
            onClick={onNo}
            sx={{ flex: 1 }}
          />
          <CustomButton
            variant='filled'
            color='primary'
            label='Yes'
            onClick={onYes}
            sx={{ flex: 1 }}
          />
        </Box>
      </Box>
    </GlassModal>
  );
};

export default ResidentCheckModal;
